import { render } from "./MiniWizardStickyPrice.vue?vue&type=template&id=cca7780c"
import script from "./MiniWizardStickyPrice.vue?vue&type=script&lang=js"
export * from "./MiniWizardStickyPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__